<template>
  <div id="navbar-progress-detail-v2">
    <div class="w-100 inter-medium_small-bold text-ui-primary mb-3 text-left">
      {{ progressDetailTitle }}
    </div>
    <div class="d-flex flex-row w-100">
      <div :class="['w-100', presenceProgressData ? 'pr-1 ' : '' ]">
        <div class="progress">
          <div
            class="progress-bar progress-bar-royal-navy"
            role="progressbar"
            :style="{ width: activityPercentage + '%' }"
            :aria-valuenow="activityProgressData.current"
            :aria-valuemin="0"
            :aria-valuemax="activityProgressData.total"
          ></div>
        </div>
      </div>
      <div v-if="presenceProgressData" class="pl-1 w-100">
        <div class="progress">
          <div
            class="progress-bar progress-bar-eucalyptus"
            role="progressbar"
            :style="{ width: presencePercentage + '%' }"
            :aria-valuenow="presenceProgressData.current"
            :aria-valuemin="0"
            :aria-valuemax="presenceProgressData.total"
          ></div>
        </div>
      </div>
    </div>
    <div class="progress-bar-total-wrapper d-flex flex-column mb-3">
      <div class="progress-bar-total inter-small-normal pt-1">
        <span class="dot dot-royal-navy"></span> {{ activityPercentage }}% Total aktivitas selesai ({{ activityProgressData.current }}/{{ activityProgressData.total }} aktivitas)
      </div>
      <div v-if="presenceProgressData" class="progress-bar-total inter-small-normal pt-1">
        <span class="dot dot-eucalyptus"></span> {{ presencePercentage }}% Kehadiran ({{ presenceProgressData.current }}/{{ presenceProgressData.total }} aktivitas)
      </div>
    </div>
    <div v-if="isSelfPacedLearning" class="inter-small-normal text-ui-primary text-left">
      Anda hanya dapat menyelesaikan pembelajaran maksimal 1 sesi per hari.
    </div>
    <div v-else-if="presenceProgressData" class="inter-small-normal text-ui-primary text-left">
      Ikuti aktivitas sesi kehadiran dan capai persentase minimal 80% sebagai salah satu syarat untuk mendapatkan sertifikat.
    </div>
    <div v-else class="inter-small-normal text-ui-primary text-left">
      Selesaikan seluruh aktivitas untuk kembangkan kemampuan sesuai dengan kompetensi terbaik Anda.
    </div>
  </div>
</template>

<script>
import programTrainingTypes from '@/constants/programTrainingTypes.js'

export default {
  name: 'ProgressDetail',
  props: {
    activityProgressData: {
      type: Object,
      required: true,
      validator (value) {
        return 'current' in value && 'total' in value
      }
    },
    presenceProgressData: {
      type: Object,
      required: false,
      validator (value) {
        return 'current' in value && 'total' in value
      }
    }
  },
  computed: {
    progressDetailTitle () {
      if (this.presenceProgressData) return 'Progres Aktivitas dan Kehadiran'
      return 'Progres Aktivitas'
    },
    activityPercentage () {
      if (this.activityProgressData?.percentage !== undefined) {
        return this.activityProgressData.percentage.toFixed(1)
      }
      return this.calculatePercentage(
        this.activityProgressData.current,
        this.activityProgressData.total
      )
    },
    presencePercentage () {
      if (this.presenceProgressData?.percentage !== undefined) {
        return this.presenceProgressData.percentage.toFixed(1)
      }
      return this.calculatePercentage(
        this.presenceProgressData.current,
        this.presenceProgressData.total
      )
    },
    isSelfPacedLearning () {
      return this.$store.state.activityV2.activityDashboard?.training_type === programTrainingTypes.SELF_PACED_LEARNING
    }
  },
  methods: {
    calculatePercentage (current, total) {
      return ((current / total) * 100).toFixed(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar-total-wrapper {
  padding-top: 8px;
}

.progress-bar-total {
  display: flex;
  align-items: center;
  text-align: start;
  gap: 8px;
}

.progress {
  height: 10px;
  background-color: var(--color-ui-element-snow);
  border-radius: 6px;

  .progress-bar {
    border-radius: 6px;
    transition: width 0.6s ease;

    &.progress-bar-royal-navy {
      background-color: var(--color-ui-element-navy-500);
    }

    &.progress-bar-eucalyptus {
      background-color: var(--color-eucalyptus-600);
    }
  }
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 100%;

  &-royal-navy {
    background-color: var(--color-ui-element-navy-500);
  }

  &-eucalyptus {
    background-color: var(--color-eucalyptus-600);
  }
}
</style>
